<template>
  <div>
    <a-row>
      <a-card>
        <g-master name="forms"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :parentData="parentData"
                  :beforeSend="master.beforeSend"
                  :actions="false"
                  ref="master"
        >
          <template slot="masterModal" slot-scope="{record}">
          </template>
        </g-master>
      </a-card>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'investigation_format',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id_investig'
            },
            columns: [
              {title: 'ID Investigación', dataIndex: 'id_investig', sorter: true},
              {title: 'Fecha y hora del accidente', dataIndex: 'fecha_hora_accidente', sorter: true},
              {title: 'Descripción del accidente', dataIndex: 'accident_desc', sorter: true}
            ]
          }
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/AccidentesDeTrabajo.vue